import {ValidatorFn} from "@angular/forms";

export const bsnValidator: ValidatorFn = (control) => {
  const value = control.value;
  const createErrorMessage = (message: string) => ({bsnValidationError: {message}});

  if(!value) {
    return null;
  }

  const intNumber = Number.parseInt(value);
  if(Number.isNaN(intNumber)) {
    return createErrorMessage('input is not a number');
  }

  const stringNumber = `${intNumber}`;
  const arrayOfDigits = stringNumber.split('');
  if(arrayOfDigits.length < 8 || arrayOfDigits.length > 9) {
    return createErrorMessage('input is too long or too short');
  }
  if(arrayOfDigits.length === 8) {
    arrayOfDigits.unshift('0');
  }

  const elevenTest = arrayOfDigits.map(Number).reduce((sum, digit, currentIndex) => sum + (digit * (currentIndex !== 8 ? (9-currentIndex): -1)), 0) % 11;
  if(elevenTest > 0) {
    return createErrorMessage('the eleven test failed, input is no valid ssn');
  }

  return null;
}
